var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTitleWinnerIcon = function SvgTitleWinnerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 70,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.495 60.114V62.484c.002.158.08.315.236.405l11.897 6.868a1.814 1.814 0 0 0 1.814 0l20.063-11.583a.469.469 0 0 0 .236-.41v-2.358L6.495 60.114Z",
    fill: "url(#title-winner-icon_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73 60.531 18.628 67.4a1.814 1.814 0 0 0 1.814 0l20.063-11.583a.473.473 0 0 0 0-.82l-11.896-6.868a1.814 1.814 0 0 0-1.814 0L6.73 59.712a.473.473 0 0 0 0 .82Z",
    fill: "url(#title-winner-icon_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.384 22.153a2.132 2.132 0 0 1-1.068-3.98l2.61-1.507a7.62 7.62 0 0 0 3.8-6.581V4.999l-4.278 2.47a2.132 2.132 0 1 1-2.132-3.694l4.725-2.728a3.926 3.926 0 0 1 3.967 0c1.241.717 1.982 2 1.982 3.435v5.603c0 4.225-2.273 8.162-5.932 10.275l-2.61 1.507a2.123 2.123 0 0 1-1.064.286Z",
    fill: "#D7D7D7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.992 46.253V59.6a.4.4 0 0 0 .202.346l10.162 5.867a1.55 1.55 0 0 0 1.549 0l17.137-9.894a.4.4 0 0 0 .202-.35V42.232L8.992 46.253Z",
    fill: "url(#title-winner-icon_svg__c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m9.194 46.61 10.162 5.866a1.55 1.55 0 0 0 1.55 0l17.136-9.894a.404.404 0 0 0 0-.7l-10.161-5.867a1.549 1.549 0 0 0-1.55 0L9.194 45.909a.404.404 0 0 0 0 .7Z",
    fill: "url(#title-winner-icon_svg__d)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m26.628 38.28-7.169.641v4.816c-.005.48.281.94.874 1.282 1.296.748 3.56.654 5.057-.21.84-.485 1.26-1.11 1.237-1.697h.001v-4.831Z",
    fill: "url(#title-winner-icon_svg__e)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.242 12.475v10.94c0 9.843 7.98 17.822 17.822 17.822 9.842 0 17.821-7.98 17.821-17.822V8.735l-35.643 3.74Z",
    fill: "url(#title-winner-icon_svg__f)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.723 17.045c7.449-4.3 8.258-10.806 1.807-14.53C30.078-1.21 18.81-.744 11.36 3.558c-7.449 4.3-8.258 10.806-1.807 14.53 6.451 3.725 17.72 3.258 25.169-1.043Z",
    fill: "url(#title-winner-icon_svg__g)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.43 15.721c5.986-3.456 6.636-8.684 1.451-11.677-5.184-2.993-14.24-2.618-20.226.838-5.986 3.456-6.636 8.684-1.452 11.677 5.184 2.994 14.24 2.618 20.226-.838Z",
    fill: "url(#title-winner-icon_svg__h)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m23.697 54.06 11.414-6.59v7.653l-11.414 6.59v-7.654Z",
    fill: "#C5BAEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.279 39.478a6.266 6.266 0 0 1-3.14-.851A6.215 6.215 0 0 1 0 33.189v-5.635c0-1.734.933-3.35 2.435-4.218l4.851-2.8a2.132 2.132 0 1 1 2.133 3.693l-4.851 2.8a.607.607 0 0 0-.303.525v5.635c0 1.05.704 1.57 1.007 1.744.303.175 1.105.525 2.014 0l2.027-1.17a2.133 2.133 0 0 1 2.132 3.693l-2.026 1.17a6.266 6.266 0 0 1-3.14.852Z",
    fill: "#D7D7D7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m34.568 55.436.542-1.037v-6.93l-.156.09-5.74 10.967 5.354-3.09Z",
    fill: "url(#title-winner-icon_svg__i)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m32.647 48.892-7.946 4.588-1.004 1.918v6.314l3.21-1.853 5.74-10.967Z",
    fill: "url(#title-winner-icon_svg__j)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.384 22.153a2.132 2.132 0 0 1-1.068-3.98l2.61-1.507a7.62 7.62 0 0 0 3.8-6.581V4.999l-4.278 2.47a2.132 2.132 0 1 1-2.132-3.694l4.725-2.728a3.926 3.926 0 0 1 3.967 0c1.241.717 1.982 2 1.982 3.435v5.603c0 4.225-2.273 8.162-5.932 10.275l-2.61 1.507a2.123 2.123 0 0 1-1.064.286Z",
    fill: "#FFC538"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m26.628 38.28-7.169.641v4.816c-.005.48.281.94.874 1.282 1.296.748 3.56.654 5.057-.21.84-.485 1.26-1.11 1.237-1.697h.001v-4.831Z",
    fill: "url(#title-winner-icon_svg__k)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.242 12.475v10.94c0 9.843 7.98 17.822 17.822 17.822 9.842 0 17.821-7.98 17.821-17.822V8.735l-35.643 3.74Z",
    fill: "url(#title-winner-icon_svg__l)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.723 17.045c7.449-4.3 8.258-10.806 1.807-14.53C30.078-1.21 18.81-.744 11.36 3.558c-7.449 4.3-8.258 10.806-1.807 14.53 6.451 3.725 17.72 3.258 25.169-1.043Z",
    fill: "url(#title-winner-icon_svg__m)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.43 15.721c5.986-3.456 6.636-8.684 1.451-11.677-5.184-2.993-14.24-2.618-20.226.838-5.986 3.456-6.636 8.684-1.452 11.677 5.184 2.994 14.24 2.618 20.226-.838Z",
    fill: "url(#title-winner-icon_svg__n)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.279 39.478a6.266 6.266 0 0 1-3.14-.851A6.215 6.215 0 0 1 0 33.189v-5.635c0-1.734.933-3.35 2.435-4.218l4.851-2.8a2.132 2.132 0 1 1 2.133 3.693l-4.851 2.8a.607.607 0 0 0-.303.525v5.635c0 1.05.704 1.57 1.007 1.744.303.175 1.105.525 2.014 0l2.027-1.17a2.133 2.133 0 0 1 2.132 3.693l-2.026 1.17a6.266 6.266 0 0 1-3.14.852Z",
    fill: "#FFC538"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "title-winner-icon_svg__a",
    x1: 17.669,
    y1: 62.703,
    x2: 22.913,
    y2: 62.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D3180"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F46B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "title-winner-icon_svg__b",
    x1: 13.181,
    y1: 63.789,
    x2: 45.813,
    y2: 44.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5155A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F93DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "title-winner-icon_svg__c",
    x1: 18.536,
    y1: 54.126,
    x2: 23.016,
    y2: 54.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D3080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F45AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "title-winner-icon_svg__d",
    x1: 14.704,
    y1: 49.392,
    x2: 42.578,
    y2: 33.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5055A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8ABF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "title-winner-icon_svg__e",
    x1: 19.459,
    y1: 41.903,
    x2: 26.628,
    y2: 41.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D2D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "title-winner-icon_svg__f",
    x1: -6.305,
    y1: 40.048,
    x2: 35.382,
    y2: 15.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.165,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "title-winner-icon_svg__g",
    x1: 11.361,
    y1: 3.571,
    x2: 23.035,
    y2: 23.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "title-winner-icon_svg__h",
    x1: 33.776,
    y1: 4.104,
    x2: 12.417,
    y2: 16.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9E9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "title-winner-icon_svg__i",
    x1: 38.109,
    y1: 56.431,
    x2: 31.252,
    y2: 52.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "title-winner-icon_svg__j",
    x1: 35.853,
    y1: 59.737,
    x2: 24.491,
    y2: 53.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "title-winner-icon_svg__k",
    x1: 19.459,
    y1: 41.903,
    x2: 26.628,
    y2: 41.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "title-winner-icon_svg__l",
    x1: -6.305,
    y1: 40.048,
    x2: 35.382,
    y2: 15.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.022,
    stopColor: "#E37C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F1C43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7E041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "title-winner-icon_svg__m",
    x1: 11.361,
    y1: 3.571,
    x2: 23.035,
    y2: 23.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7E041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "title-winner-icon_svg__n",
    x1: 33.776,
    y1: 4.104,
    x2: 12.417,
    y2: 16.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC538"
  })))));
};
export default SvgTitleWinnerIcon;